import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import ServicesSection from '../components/home/ServicesSection';
import MediaSection from '../components/home/MediaSection';
import ProcessSection from '../components/home/ProcessSection';
import GuaranteeSection from '../components/home/GuaranteeSection';
import LocationSection from '../components/home/LocationSection';
import ContactSection from '../components/home/ContactSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <MediaSection />
        <ProcessSection />
        <GuaranteeSection />
        <LocationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
